import { createContext, useContext, useEffect, useState } from 'react'
import api from '../api/axios'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true

    api.get('/auth/me')
      .then(({ data, status }) => {
        if (!active) return
        if (status === 204 || !data) {
          setUser(null)
          return
        }
        setUser(data)
      })
      .catch(() => {
        if (active) setUser(null)
      })
      .finally(() => {
        if (active) setLoading(false)
      })

    return () => { active = false }
  }, [])

  const login = (data) => {
    setUser(data)
  }

  const logout = () => {
    setUser(null)
    api.post('/auth/logout').catch(() => {})
  }

  const switchRole = async () => {
    const { data } = await api.post('/profile/switch-role')
    setUser(data)
    return data.role
  }

  // Re-fetch the current auth/me payload (e.g. after accepting consent).
  const refreshAuth = async () => {
    const { data, status } = await api.get('/auth/me')
    if (status === 204 || !data) {
      setUser(null)
      return null
    }
    setUser(data)
    return data
  }

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, switchRole, refreshAuth, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
